module.exports = __webpack_public_path__ + "static/media/itcons.6132e78f.png";